/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { message } from 'antd';
import s from './NewTemplate.css';
import Breadcrumbs from '../../components/Breadcrumbs';
import Textarea from '../../components/Textarea';
import { Link } from 'react-router-dom';
import history from '../../history';

class NewTemplate extends React.Component {
  static propTypes = {
    locale: PropTypes.objectOf(PropTypes.string).isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      name: '',
      text: '',
      config: require('Config'),
    };
    this.nameChange = this.nameChange.bind(this);
    this.textChange = this.textChange.bind(this);
  }

  nameChange(event) {
    this.setState({ name: event.target.value });
  }

  textChange(value) {
    this.setState({ text: value });
  }

  successMessage = () => {
    message.success(this.props.locale.messageSuccess, 2);
  };

  errorMessage = (error) => {
    message.error(`${this.props.locale.messageError} ${error}`, 5);
  };

  addTemplate = (e) => {
    e.preventDefault();
    fetch(this.state.config.serverUrl + `texts/add`,
      {
        headers: new Headers({
            'Authorization': `Bearer ${sessionStorage.getItem("authenticationtoken")}`,
            'Content-Type': 'application/json',
            'username': `${sessionStorage.getItem('username')}`
        }),
        method: 'POST',
        body: JSON.stringify({ name: this.state.name, text: this.state.text }),
      },
    )
      .then((response) => {
        if (response.status === 201) {
          this.successMessage();
          history.push('/templates');
        } else {
          this.errorMessage(response.statusText);
        }
      });
  };

  render() {
    return (
      <div className={s.root}>
        <Breadcrumbs title={this.props.locale.breadcrumbs} link="/templates" />
        <h1>{this.props.locale.title}</h1>
        <form onSubmit={this.addTemplate}>
          <label className={s.input_wrapper} htmlFor="input">
            <span className={s.input_name}>{this.props.locale.nameLabel}</span>
            <input
              className={s.text_input}
              name="input"
              placeholder={this.props.locale.namePlaceholder}
              onChange={this.nameChange}
            />
          </label>
          <label className={s.input_wrapper} htmlFor="message">
            <span className={s.input_name}>{this.props.locale.textLabel}</span>
            <Textarea
              name="message"
              placeholder={this.props.locale.textPlaceholder}
              rows="4"
              value={this.state.text}
              ontextchange={this.textChange}
              showsaveoption={false}
            />
          </label>
          <div className={s.button_wrapper}>
            <Link className={s.btn_warning} to="/templates">{this.props.locale.buttonCancel}</Link>
            <button className={s.btn_primary}>{this.props.locale.buttonAdd}</button>
          </div>
        </form>
      </div>
    );
  }
}

export default (NewTemplate);




// WEBPACK FOOTER //
// ./src/routes/templates/NewTemplate.js